import { jarvisPrimeTransactionConstants } from "./jarvisPrimeTransactionConstants";

const jarvisPrimeTransactionActions = {};

jarvisPrimeTransactionActions.getTransactionList = ({ page, rowsPerPage }) => ({
    type: jarvisPrimeTransactionConstants.PRIME_TRANSACTION_LIST_SAGA,
    payload: { page, rowsPerPage },
});

export { jarvisPrimeTransactionActions };
